(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
(function () {
  var prose     = document.getElementById('art-prose');
  var convBlock = document.getElementById('art-conv-block');

  if (prose && convBlock) {
    var paras = prose.querySelectorAll('p');
    convBlock.style.display = '';
    if (paras.length >= 3) {
      paras[2].parentNode.insertBefore(convBlock, paras[2].nextSibling);
    } else if (paras.length > 0) {
      var last = paras[paras.length - 1];
      last.parentNode.insertBefore(convBlock, last.nextSibling);
    } else {
      prose.appendChild(convBlock);
    }
  }

  var sticky = document.getElementById('art-sticky-cta');
  if (sticky) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 400) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
    }, { passive: true });

    var btn = sticky.querySelector('.art-sticky__btn');
    if (btn) btn.addEventListener('click', function () {
      var target = document.getElementById('art-conv-block');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initBestSellers(root) {
    root.querySelectorAll('.best-sellers__card form').forEach(function (form) {
      if (form.dataset.bsInit) return;
      form.dataset.bsInit = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.best-sellers__atc');
        var id = form.querySelector('[name="id"]').value;
        var originalText = btn.textContent.trim();

        btn.disabled = true;
        btn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = 'Added ✓';
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = originalText;
            }, 1800);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = originalText;
          });
      });
    });
  }

  initBestSellers(document);

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target.querySelector && evt.target.querySelector('.best-sellers')) {
      initBestSellers(evt.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bought-together"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initBoughtTogether(root) {
    root.querySelectorAll('.bundle-card__atc').forEach(function (btn) {
      if (btn.dataset.btInit) return;
      btn.dataset.btInit = '1';
      btn.addEventListener('click', function () {
        var ids = (btn.getAttribute('data-bundle-ids') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        if (!ids.length) return;

        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = 'Adding…';

        var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.innerHTML = '✓ Added!';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              btn.disabled = false;
              btn.innerHTML = originalHTML;
            }, 1800);
          })
          .catch(function () {
            btn.disabled = false;
            btn.innerHTML = originalHTML;
          });
      });
    });
  }

  initBoughtTogether(document);

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target.querySelector && evt.target.querySelector('.bought-together')) {
      initBoughtTogether(evt.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var overlay  = document.getElementById('cart-drawer-overlay');
  var drawer   = document.getElementById('cart-drawer');
  var closeBtn = document.getElementById('cd-close');
  var emptyCta = document.getElementById('cd-empty-cta');
  if (!drawer) return;

  var THRESHOLD = parseInt(drawer.getAttribute('data-threshold'), 10) || 99900;

  /* ── Helpers ─────────────────────────────────────────────── */
  function money(paise) {
    var r = Math.round(paise / 100);
    return '₹' + r.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function el(id) { return document.getElementById(id); }

  function showEl(id, show) {
    var e = el(id);
    if (!e) return;
    if (show) e.removeAttribute('hidden');
    else e.setAttribute('hidden', '');
  }

  var CHECKOUT_URL = drawer.getAttribute('data-checkout-url') || '/checkout';

  /* ── Open / close ────────────────────────────────────────── */
  function openCartDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchAndRender();
  }

  function closeCartDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function goToCheckout(e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/checkout';
  }

  /* ── Fetch cart and render ───────────────────────────────── */
  function fetchAndRender() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function (err) { console.error('[CartDrawer] fetch error', err); });
  }

  /* ── Update shipping bar ─────────────────────────────────── */
  function updateShippingBar(totalPaise) {
    var shippingEl = el('cd-shipping');
    var msgEl      = el('cd-shipping-msg');
    var fillEl     = el('cd-shipping-fill');
    if (!shippingEl || !msgEl || !fillEl) return;

    var pct       = Math.min((totalPaise / THRESHOLD) * 100, 100);
    var remaining = Math.max(0, THRESHOLD - totalPaise);

    fillEl.style.width = pct + '%';

    if (remaining > 0) {
      msgEl.innerHTML = 'Add <strong>' + money(remaining) + '</strong> more for FREE shipping';
    } else {
      msgEl.innerHTML = '<strong>🎉 Free shipping unlocked</strong>';
    }
  }

  /* ── Build line items HTML ───────────────────────────────── */
  function buildLineItemsHTML(items) {
    if (!items || !items.length) return '';

    return items.map(function (item, idx) {
      var lineIndex = idx + 1;
      var imgHTML = item.image
        ? '<img src="' + item.image + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" class="cart-line-item__img" loading="lazy" width="56" height="56">'
        : '<div class="cart-line-item__img-placeholder"></div>';

      var variantHTML = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-line-item__variant">' + item.variant_title + '</p>'
        : '';

      return '<div class="cart-line-item" data-line="' + lineIndex + '">'
        + imgHTML
        + '<div class="cart-line-item__info">'
          + '<p class="cart-line-item__title">' + (item.product_title || item.title || '') + '</p>'
          + variantHTML
          + '<div class="cart-line-item__controls">'
            + '<div class="cart-line-item__stepper">'
              + '<button type="button" class="cart-line-item__stepper-btn" data-action="decrease" data-line="' + lineIndex + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">'
                + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/></svg>'
              + '</button>'
              + '<span class="cart-line-item__qty">' + item.quantity + '</span>'
              + '<button type="button" class="cart-line-item__stepper-btn" data-action="increase" data-line="' + lineIndex + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">'
                + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>'
              + '</button>'
              + '<button type="button" class="cart-line-item__remove" data-action="remove" data-line="' + lineIndex + '" aria-label="Remove item">'
                + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>'
              + '</button>'
            + '</div>'
            + '<span class="cart-line-item__price">' + money(item.line_price) + '</span>'
          + '</div>'
        + '</div>'
        + '</div>';
    }).join('');
  }

  /* ── Build totals HTML ───────────────────────────────────── */
  function buildTotalsHTML(cart) {
    var subtotal  = cart.items_subtotal_price;
    var total     = cart.total_price;
    var isFree    = subtotal >= THRESHOLD;
    var shippingHTML = isFree
      ? '<span class="cart-drawer__totals-row--free">FREE ✓</span>'
      : '<span>' + money(Math.max(0, THRESHOLD - subtotal)) + ' away from free</span>';

    return '<div class="cart-drawer__totals-row"><span>Subtotal</span><span>' + money(subtotal) + '</span></div>'
      + '<div class="cart-drawer__totals-row"><span>Shipping</span>' + shippingHTML + '</div>'
      + '<div class="cart-drawer__totals-grand"><span>Total</span><span class="cart-drawer__totals-grand-amt">' + money(total) + '</span></div>';
  }

  /* ── Update recommended product visibility ───────────────── */
  function updateRecommended(cartItems) {
    var cartProductIds = (cartItems || []).map(function (i) { return String(i.product_id); });
    var recItems = document.querySelectorAll('.cart-rec-item[data-product-id]');
    var anyVisible = false;
    recItems.forEach(function (item) {
      var pid = item.getAttribute('data-product-id');
      if (cartProductIds.indexOf(pid) !== -1) {
        item.setAttribute('hidden', '');
      } else {
        item.removeAttribute('hidden');
        anyVisible = true;
      }
    });
    showEl('cd-recs', anyVisible);
  }

  /* ── Main render function ────────────────────────────────── */
  function renderCart(cart) {
    var hasItems  = cart.item_count > 0;
    var countEl   = el('cd-count');
    if (countEl) countEl.textContent = cart.item_count;

    /* Shipping bar */
    showEl('cd-shipping', hasItems);
    if (hasItems) updateShippingBar(cart.total_price);

    /* Toggle empty vs filled state */
    showEl('cd-empty',           !hasItems);
    showEl('cd-items',            hasItems);
    showEl('cd-totals',           hasItems);
    showEl('cd-trust',            hasItems);
    showEl('cd-founder',          hasItems);
    showEl('cd-social',           hasItems);
    showEl('cd-checkout-inline',  hasItems);
    showEl('cd-guarantee',        hasItems);
    showEl('cd-book-call',        hasItems);
    showEl('cd-scarcity',         hasItems);
    showEl('cd-footer',           hasItems);

    /* Line items */
    var itemsEl = el('cd-items');
    if (itemsEl) itemsEl.innerHTML = buildLineItemsHTML(cart.items);

    /* Totals */
    var totalsEl = el('cd-totals');
    if (totalsEl) totalsEl.innerHTML = buildTotalsHTML(cart);

    /* Footer total */
    var footerTotal = el('cd-footer-total');
    if (footerTotal) footerTotal.textContent = money(cart.total_price) + ' →';

    /* Recommended products */
    updateRecommended(cart.items);

    /* Attach quantity/remove listeners */
    attachLineItemListeners();
  }

  /* ── Attach listeners to line item buttons ───────────────── */
  function attachLineItemListeners() {
    var scope = document.getElementById('cd-items');
    if (!scope) return;
    var btns = scope.querySelectorAll('[data-action]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.getAttribute('data-action');
        var line   = parseInt(btn.getAttribute('data-line'), 10);
        var qty    = parseInt(btn.getAttribute('data-qty'), 10);

        if (action === 'remove' || qty === 0) {
          removeItem(line);
        } else {
          updateQuantity(line, Math.max(0, qty));
        }
      });
    });
  }

  /* ── updateQuantity ──────────────────────────────────────── */
  function updateQuantity(line, newQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      })
      .catch(function (err) { console.error('[CartDrawer] updateQuantity error', err); });
  }

  /* ── removeItem ──────────────────────────────────────────── */
  function removeItem(line) {
    updateQuantity(line, 0);
  }

  /* ── addToCart (globally available) ─────────────────────── */
  function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var msg = (data && (data.description || data.message)) || ('HTTP ' + r.status);
            var err = new Error(msg);
            err.data = data;
            throw err;
          }
          return data;
        });
      })
      .then(function (data) {
        openCartDrawer();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return data;
      })
      .catch(function (err) {
        console.error('[CartDrawer] addToCart error', err);
        throw err;
      });
  }

  /* ── Recommended product add buttons ─────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-rec-item__add[data-variant-id]');
    if (!btn) return;
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    addToCart(vid, 1).then(function () {
      btn.textContent = 'Added ✓';
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = '+ Add';
      }, 1800);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = '+ Add';
    });
  });

  /* ── Wire open/close ─────────────────────────────────────── */
  function wireCartDrawer() {
    /* Cart icon in header */
    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });

    /* Close button */
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);

    /* Backdrop */
    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    /* Empty state CTA closes drawer */
    if (emptyCta) emptyCta.addEventListener('click', closeCartDrawer);

    /* Checkout buttons — explicit navigation to prevent event bubbling closing drawer */
    var footerBtn   = document.getElementById('cd-footer-btn');
    var inlineBtn   = document.getElementById('cd-checkout-inline');
    if (footerBtn)  footerBtn.addEventListener('click',  goToCheckout);
    if (inlineBtn)  inlineBtn.addEventListener('click',  goToCheckout);

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireCartDrawer);
  } else {
    wireCartDrawer();
  }

  /* ── Expose global API ───────────────────────────────────── */
  window.addToCart = addToCart;
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  'use strict';

  function money(paise) {
    return '₹' + Math.round(paise / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function reloadPage() {
    window.location.reload();
  }

  function cartChange(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function () { reloadPage(); })
    .catch(function (err) { console.error('[CartPage]', err); reloadPage(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action][data-line]');
    if (!btn) return;

    var action = btn.getAttribute('data-action');
    var line   = parseInt(btn.getAttribute('data-line'), 10);
    var qty    = parseInt(btn.getAttribute('data-qty'), 10);

    if (action === 'remove') {
      cartChange(line, 0);
    } else if (action === 'decrease') {
      cartChange(line, Math.max(0, qty));
    } else if (action === 'increase') {
      cartChange(line, qty);
    }
  });

  /* Prevent the form from submitting — we use the AJAX stepper + /checkout link */
  var form = document.getElementById('cart-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
    });
  }

  /* Checkout button: prevent any parent form submit, navigate directly */
  var checkoutBtn = document.getElementById('cart-checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/checkout';
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-page"]) return;
  try {
    
(function () {

  // ── Sort dropdown ────────────────────────────────────────
  var sortSelect = document.getElementById('cp-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // ── Add to cart ──────────────────────────────────────────
  document.querySelectorAll('.cp-card__atc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = parseInt(btn.getAttribute('data-variant-id') || '0', 10);
      if (!variantId || typeof window.addToCart !== 'function') return;

      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      window.addToCart(variantId, 1)
        .then(function () {
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            btn.disabled = false;
            btn.innerHTML = originalHTML;
          }, 1800);
        })
        .catch(function () {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        });
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exit-intent-popup"]) return;
  try {
    
(function () {
  var STORAGE_KEY = 'exit_shown';
  var overlay = document.getElementById('ei-overlay');
  if (!overlay) return;

  var wanum = overlay.getAttribute('data-wanum') || '';

  if (sessionStorage.getItem(STORAGE_KEY)) return;

  var path = window.location.pathname;
  if (path.indexOf('/checkout') !== -1 || path === '/cart') return;

  if (path.indexOf('/products/') !== -1) {
    sessionStorage.setItem('po_visited_product', '1');
  }

  window.po = window.po || {};
  // welcomeOpen is owned by welcome-popup; do not reset it here.

  var triggered = false;
  var ready = false;
  var mobileTimer = null;

  setTimeout(function () {
    ready = true;
  }, 30000);

  function showVariant(variant) {
    var ids = ['ei-variant-a', 'ei-variant-b', 'ei-variant-c'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el) el.setAttribute('hidden', '');
    }
    var target = document.getElementById('ei-variant-' + variant);
    if (target) target.removeAttribute('hidden');

    overlay.removeAttribute('aria-hidden');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    sessionStorage.setItem(STORAGE_KEY, '1');
    triggered = true;
  }

  function trigger() {
    if (triggered || !ready) return;
    if (window.po && window.po.welcomeOpen) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) {
          showVariant('a');
        } else if (sessionStorage.getItem('po_visited_product')) {
          showVariant('b');
        } else {
          showVariant('c');
        }
      })
      .catch(function () {
        showVariant('c');
      });
  }

  document.addEventListener('mousemove', function (e) {
    if (!ready || triggered) return;
    if (e.clientY < 20) trigger();
  });

  var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (isTouchDevice) {
    function resetMobileTimer() {
      clearTimeout(mobileTimer);
      mobileTimer = setTimeout(trigger, 60000);
    }
    document.addEventListener('touchstart', resetMobileTimer, { passive: true });
    resetMobileTimer();
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  var closeBtns = overlay.querySelectorAll('[data-close]');
  for (var i = 0; i < closeBtns.length; i++) {
    closeBtns[i].addEventListener('click', closePopup);
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup();
  });

  var waLinkB = document.getElementById('ei-wa-link-b');
  if (waLinkB && wanum) {
    var msg = 'Hi! I saw you have a welcome gift. I\'d love to claim it for my first Parwaaz order.';
    waLinkB.setAttribute('href', 'https://wa.me/' + wanum + '?text=' + encodeURIComponent(msg));
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-article"]) return;
  try {
    
(function () {
  var prose    = document.getElementById('ga-prose');
  var sideList = document.getElementById('ga-sidebar-list');
  var mobList  = document.getElementById('ga-toc-mobile-list');
  var mobBtn   = document.getElementById('ga-toc-mobile-btn');
  var mobWrap  = document.getElementById('ga-toc-mobile-wrap');

  if (!prose) return;

  var headings = prose.querySelectorAll('h2, h3');
  if (headings.length === 0) {
    if (mobWrap) mobWrap.style.display = 'none';
    return;
  }

  headings.forEach(function (h, i) {
    if (!h.id) h.id = 'ga-h-' + i;

    /* Sidebar link */
    if (sideList) {
      var li = document.createElement('li');
      var a  = document.createElement('a');
      a.className   = 'ga-sidebar__link' + (h.tagName === 'H3' ? ' ga-sidebar__link--sub' : '');
      a.href        = '#' + h.id;
      a.textContent = h.textContent;
      a.dataset.hid = h.id;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      li.appendChild(a);
      sideList.appendChild(li);
    }

    /* Mobile link */
    if (mobList) {
      var mLi = document.createElement('li');
      var mA  = document.createElement('a');
      mA.className  = 'ga-toc-mobile__link';
      mA.href       = '#' + h.id;
      mA.textContent = h.textContent;
      mA.addEventListener('click', function (e) {
        e.preventDefault();
        mobList.classList.remove('is-open');
        mobBtn && mobBtn.setAttribute('aria-expanded', 'false');
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      mLi.appendChild(mA);
      mobList.appendChild(mLi);
    }
  });

  /* Mobile toggle */
  if (mobBtn && mobList) {
    mobBtn.addEventListener('click', function () {
      var open = mobList.classList.toggle('is-open');
      mobBtn.setAttribute('aria-expanded', String(open));
    });
  }

  /* Active heading via IntersectionObserver */
  if ('IntersectionObserver' in window && sideList) {
    var sideLinks = sideList.querySelectorAll('.ga-sidebar__link');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var id = entry.target.id;
          sideLinks.forEach(function (lnk) {
            lnk.classList.toggle('is-active', lnk.dataset.hid === id);
          });
        }
      });
    }, { threshold: 0, rootMargin: '-10% 0px -75% 0px' });
    headings.forEach(function (h) { io.observe(h); });
  }

  /* Add-to-cart */
  document.querySelectorAll('.ga-shop__atc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var vid = parseInt(btn.getAttribute('data-vid') || '0', 10);
      if (!vid || typeof window.addToCart !== 'function') return;
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      window.addToCart(vid, 1)
        .then(function () {
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1800);
        })
        .catch(function () { btn.disabled = false; btn.textContent = orig; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guides-index"]) return;
  try {
    
(function () {
  var catBtns = document.querySelectorAll('.gi-cats__btn');
  var chips = document.querySelectorAll('.gi-chip[data-tag]');
  var chipClear = document.getElementById('gi-chip-clear');
  var cards = document.querySelectorAll('.gi-card');
  var searchInput = document.getElementById('gi-search');
  var searchClear = document.getElementById('gi-search-clear');
  var emptyEl = document.getElementById('gi-empty');
  var hubEl = document.getElementById('gi-hub');
  var catHdEl = document.getElementById('gi-cat-hd');
  var browsHdEl = document.querySelector('.gi-browse-hd');
  var activeCat = '';
  var activeTags = [];
  var searchQ = '';
  var featuredHref = '';

  var catConfig = {
    'start-here':      { label: 'Start Here',        desc: 'New to preventive nutrition? Begin your journey with simple, actionable guides.' },
    'health-goals':    { label: 'Health Goals',       desc: 'Targeted guidance for digestion, immunity, energy, sugar balance and more.' },
    'ingredients':     { label: 'Ingredient Guides',  desc: 'Deep dives into honey, moringa, ghee, turmeric and other healing foods.' },
    'daily-routines':  { label: 'Daily Routines',     desc: 'Simple morning, evening and weekly wellness routines for the whole family.' },
    'pure-food-guides':{ label: 'Pure Food Guides',   desc: 'Learn to identify real food, read labels, and avoid adulteration.' },
    'recipes':         { label: 'Recipes',            desc: 'Wholesome breakfast ideas, wellness drinks, millet bowls and honey recipes.' },
    'faqs':            { label: 'Quick Answers',      desc: 'Frequently asked questions about products, wellness and purity.' },
    'research':        { label: 'Research',           desc: 'Science-backed insights on preventive nutrition and traditional foods.' },
    'journal':         { label: 'Parwaaz Journal',    desc: 'In-depth articles on health, nutrition, and wellness from our team.' }
  };
  var catIcons = {
    'start-here':      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>',
    'health-goals':    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    'ingredients':     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>',
    'daily-routines':  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32 1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32 1.41-1.41"/></svg>',
    'pure-food-guides':'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>',
    'recipes':         '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3v2"/></svg>',
    'faqs':            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>',
    'research':        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2"/><path d="M8.5 2h7"/><path d="M7 16h10"/></svg>',
    'journal':         '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>'
  };

  function updateHub() {
    var cfg = catConfig[activeCat];
    if (hubEl) {
      if (activeCat === '') { hubEl.removeAttribute('hidden'); } else { hubEl.setAttribute('hidden', ''); }
    }
    if (catHdEl) {
      if (activeCat && cfg) {
        var iconEl = document.getElementById('gi-cat-hd-icon');
        var hEl = document.getElementById('gi-cat-hd-h');
        var pEl = document.getElementById('gi-cat-hd-p');
        if (iconEl) iconEl.innerHTML = catIcons[activeCat] || '';
        if (hEl) hEl.textContent = cfg.label;
        if (pEl) pEl.textContent = cfg.desc;
        catHdEl.removeAttribute('hidden');
      } else {
        catHdEl.setAttribute('hidden', '');
      }
    }
    if (browsHdEl) {
      if (activeCat) { browsHdEl.style.display = 'none'; } else { browsHdEl.style.display = ''; }
    }
  }

  function updateChipsForCat() {
    if (!activeCat) {
      chips.forEach(function (c) { c.style.display = ''; });
      return;
    }
    var catTags = {};
    cards.forEach(function (card) {
      if (card.getAttribute('data-cat') === activeCat) {
        (card.getAttribute('data-tags') || '').split(',').forEach(function (t) {
          var tag = t.trim();
          if (tag) catTags[tag] = true;
        });
      }
    });
    chips.forEach(function (chip) {
      var tag = chip.getAttribute('data-tag') || '';
      chip.style.display = catTags[tag] ? '' : 'none';
    });
    // Clear active tags that are no longer visible
    activeTags = activeTags.filter(function (t) { return catTags[t]; });
    chips.forEach(function (c) {
      var t = c.getAttribute('data-tag') || '';
      if (!catTags[t]) c.classList.remove('is-active');
    });
    if (chipClear) { chipClear.toggleAttribute('hidden', activeTags.length === 0); }
  }

  function updateFeatured() {
    var bannerEl = document.getElementById('gi-featured');
    if (!bannerEl) { featuredHref = ''; return; }
    if (!activeCat || activeTags.length > 0 || searchQ.length >= 2) {
      featuredHref = '';
      bannerEl.setAttribute('hidden', '');
      return;
    }
    var featCard = null;
    cards.forEach(function (c) {
      if (c.getAttribute('data-cat') === activeCat && c.getAttribute('data-featured') === '1') {
        featCard = c;
      }
    });
    if (!featCard) { featuredHref = ''; bannerEl.setAttribute('hidden', ''); return; }
    featuredHref = featCard.getAttribute('href') || '';
    bannerEl.setAttribute('href', featuredHref);
    var hEl = bannerEl.querySelector('.gi-featured__h');
    var pEl = bannerEl.querySelector('.gi-featured__p');
    var tEl = bannerEl.querySelector('.gi-featured__time');
    if (hEl) hEl.textContent = featCard.getAttribute('data-title') || '';
    if (pEl) pEl.textContent = featCard.getAttribute('data-excerpt') || '';
    if (tEl) {
      var timeCard = featCard.querySelector('.gi-card__time');
      tEl.textContent = timeCard ? timeCard.textContent.trim() : '';
    }
    bannerEl.removeAttribute('hidden');
  }

  function applyFilters() {
    var q = searchQ.toLowerCase();
    var vis = 0;
    cards.forEach(function (card) {
      if (featuredHref && card.getAttribute('href') === featuredHref) {
        card.setAttribute('hidden', '');
        return;
      }
      var cat = card.getAttribute('data-cat') || '';
      var tags = (card.getAttribute('data-tags') || '').split(',');
      var title = (card.getAttribute('data-title') || '').toLowerCase();
      var excerpt = (card.getAttribute('data-excerpt') || '').toLowerCase();
      var catOk = activeCat === '' || cat === activeCat;
      var tagOk = activeTags.length === 0 || activeTags.some(function (t) { return tags.indexOf(t) !== -1; });
      var qOk = q.length < 2 || title.indexOf(q) !== -1 || excerpt.indexOf(q) !== -1;
      if (catOk && tagOk && qOk) { card.removeAttribute('hidden'); vis++; }
      else { card.setAttribute('hidden', ''); }
    });
    if (emptyEl) { if (vis === 0) { emptyEl.removeAttribute('hidden'); } else { emptyEl.setAttribute('hidden', ''); } }
  }

  catBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      activeCat = btn.getAttribute('data-cat') || '';
      catBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      updateHub();
      updateChipsForCat();
      updateFeatured();
      applyFilters();
    });
  });

  document.querySelectorAll('[data-cat-trigger]').forEach(function (el) {
    el.addEventListener('click', function () {
      var catVal = el.getAttribute('data-cat-trigger');
      catBtns.forEach(function (b) {
        if (b.getAttribute('data-cat') === catVal) { b.click(); }
      });
      var catsEl = document.getElementById('gi-cats');
      if (catsEl) { catsEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var tag = chip.getAttribute('data-tag') || '';
      var idx = activeTags.indexOf(tag);
      if (idx === -1) { activeTags.push(tag); chip.classList.add('is-active'); }
      else { activeTags.splice(idx, 1); chip.classList.remove('is-active'); }
      if (chipClear) { chipClear.toggleAttribute('hidden', activeTags.length === 0); }
      updateFeatured();
      applyFilters();
    });
  });

  if (chipClear) {
    chipClear.addEventListener('click', function () {
      activeTags = [];
      chips.forEach(function (c) { c.classList.remove('is-active'); });
      chipClear.setAttribute('hidden', '');
      updateFeatured();
      applyFilters();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      searchQ = searchInput.value;
      if (searchClear) { searchClear.toggleAttribute('hidden', searchQ === ''); }
      updateFeatured();
      applyFilters();
    });
    if (searchClear) {
      searchClear.addEventListener('click', function () {
        searchQ = ''; searchInput.value = ''; searchClear.setAttribute('hidden', '');
        updateFeatured();
        applyFilters();
      });
    }
  }

  var urlCat = new URLSearchParams(window.location.search).get('cat') || '';
  var defaultCat = (document.getElementById('gi-cats') || {}).getAttribute('data-default-cat') || '';
  var initCat = urlCat || defaultCat;
  if (initCat) {
    catBtns.forEach(function (btn) { if (btn.getAttribute('data-cat') === initCat) btn.click(); });
  }

  var catsEl = document.getElementById('gi-cats');
  if (catsEl) {
    var catsTop = catsEl.getBoundingClientRect().top + window.scrollY;
    window.addEventListener('scroll', function () {
      catsEl.classList.toggle('is-sticky', window.scrollY > catsTop);
    }, { passive: true });
  }

  document.querySelectorAll('.gi-shop__atc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var vid = parseInt(btn.getAttribute('data-vid') || '0', 10);
      if (!vid || typeof window.addToCart !== 'function') return;
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = '…';
      window.addToCart(vid, 1)
        .then(function () { btn.textContent = '✓'; setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1800); })
        .catch(function () { btn.disabled = false; btn.textContent = orig; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  'use strict';

  function init() {
    /* Keep page flow aligned with the fixed header at every viewport size. */
    var headerWrapper = document.querySelector('.header-wrapper');
    var headerSpacer = document.querySelector('.header-spacer');
    if (headerWrapper && headerSpacer) {
      function syncHeaderHeight() {
        headerSpacer.style.setProperty('--site-header-height', headerWrapper.offsetHeight + 'px');
      }
      syncHeaderHeight();
      if ('ResizeObserver' in window) {
        new ResizeObserver(syncHeaderHeight).observe(headerWrapper);
      } else {
        window.addEventListener('resize', syncHeaderHeight);
      }
    }

    /* Announcement bar rotation */
    var items = document.querySelectorAll('.announcement-bar__item');
    var idx = 0;
    function showItem(i) {
      items.forEach(function (el) { el.classList.remove('is-active'); });
      if (items[i]) items[i].classList.add('is-active');
    }
    if (items.length > 1) {
      setInterval(function () {
        idx = (idx + 1) % items.length;
        showItem(idx);
      }, 4000);
    }

    /* Mega menu — CSS :has() handles hover (see stylesheet above).
       JS handles click-toggle (keyboard / accessibility) and
       outside-click close only. */
    var shopNavItem = document.getElementById('shop-nav-item');
    var shopTrigger = document.getElementById('shop-trigger');
    var megaMenu    = document.getElementById('mega-menu');
    if (shopNavItem && shopTrigger && megaMenu) {
      function openMega() {
        megaMenu.removeAttribute('hidden');
        shopTrigger.setAttribute('aria-expanded', 'true');
      }
      function closeMega() {
        megaMenu.setAttribute('hidden', '');
        shopTrigger.setAttribute('aria-expanded', 'false');
      }
      shopTrigger.addEventListener('click', function () {
        megaMenu.hasAttribute('hidden') ? openMega() : closeMega();
      });
      document.addEventListener('pointerdown', function (e) {
        if (!shopNavItem.contains(e.target) && !megaMenu.contains(e.target)) {
          closeMega();
        }
      });
    }

    /* More dropdown */
    var moreTrigger  = document.getElementById('more-trigger');
    var moreDropdown = document.getElementById('more-dropdown');
    var moreMenu     = document.getElementById('more-menu');
    if (moreTrigger && moreDropdown) {
      moreTrigger.addEventListener('click', function () {
        var hidden = moreDropdown.hasAttribute('hidden');
        moreDropdown.toggleAttribute('hidden', !hidden);
        moreTrigger.setAttribute('aria-expanded', hidden ? 'true' : 'false');
      });
      document.addEventListener('pointerdown', function (e) {
        if (moreMenu && !moreMenu.contains(e.target)) {
          moreDropdown.setAttribute('hidden', '');
          moreTrigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* Mobile drawer */
    var mobileToggle = document.getElementById('mobile-toggle');
    var mobileDrawer = document.getElementById('mobile-drawer');
    var drawerClose  = document.getElementById('mobile-drawer-close');
    if (mobileToggle && mobileDrawer) {
      mobileToggle.addEventListener('click', function () {
        mobileDrawer.showModal();
        mobileToggle.setAttribute('aria-expanded', 'true');
      });
      function closeDrawer() {
        mobileDrawer.close();
        mobileToggle.setAttribute('aria-expanded', 'false');
      }
      if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
      mobileDrawer.addEventListener('click', function (e) {
        if (e.target === mobileDrawer) closeDrawer();
      });
      mobileDrawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeDrawer);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["health-goals"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function initHealthGoals(root) {
    var btn = root.querySelector('.health-goals__more');
    var inner = root.querySelector('.health-goals__inner');
    if (!btn || !inner) return;
    btn.addEventListener('click', function () {
      inner.classList.add('health-goals--expanded');
    });
  }
  document.querySelectorAll('.health-goals').forEach(initHealthGoals);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.health-goals').forEach(initHealthGoals);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-cta"]) return;
  try {
    
(function () {
  var btn = document.getElementById('hg-cta-atc');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var vid = parseInt(btn.getAttribute('data-vid') || '0', 10);
    if (!vid || typeof window.addToCart !== 'function') return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    window.addToCart(vid, 1)
      .then(function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1800);
      })
      .catch(function () { btn.disabled = false; btn.textContent = orig; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-kit"]) return;
  try {
    
(function () {
  var btn = document.getElementById('hg-kit-atc');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var vid = parseInt(btn.getAttribute('data-vid') || '0', 10);
    if (!vid || typeof window.addToCart !== 'function') return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    window.addToCart(vid, 1)
      .then(function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1800);
      })
      .catch(function () { btn.disabled = false; btn.textContent = orig; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-wellness-kits"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function addToCartAndOpen(variantIds, btn) {
    var items = variantIds.split(',').filter(Boolean).map(function (id) {
      return { id: parseInt(id, 10), quantity: 1 };
    });
    btn.disabled = true;
    var orig = btn.innerHTML;
    btn.innerHTML = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        btn.innerHTML = 'Added ✓';
        setTimeout(function () {
          btn.disabled = false;
          btn.innerHTML = orig;
        }, 2000);
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = orig;
      });
  }

  function initHwkSection(root) {
    root.querySelectorAll('[data-hwk-kit-btn]').forEach(function (btn) {
      if (btn.dataset.hwkInit) return;
      btn.dataset.hwkInit = '1';
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (id) addToCartAndOpen(id, btn);
      });
    });

    root.querySelectorAll('[data-hwk-bundle-btn]').forEach(function (btn) {
      if (btn.dataset.hwkInit) return;
      btn.dataset.hwkInit = '1';
      btn.addEventListener('click', function () {
        var ids = btn.getAttribute('data-variant-ids');
        if (ids) addToCartAndOpen(ids, btn);
      });
    });
  }

  initHwkSection(document);

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target.querySelector && evt.target.querySelector('.hwk')) {
      initHwkSection(evt.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"]) return;
  try {
    
(function () {
  // ?? Gallery ??????????????????????????????????????????????
  var galleryImg = document.getElementById('pd-gallery-img');
  var thumbs = document.querySelectorAll('.pd-gallery__thumb');
  var dots = document.querySelectorAll('.pd-gallery__dot');
  var prevBtn = document.getElementById('pd-prev');
  var nextBtn = document.getElementById('pd-next');
  var currentIdx = 0;
  var imgUrls = [];
  var imgAlts = [];

  thumbs.forEach(function (thumb, i) {
    imgUrls.push(thumb.getAttribute('data-src'));
    imgAlts.push(thumb.getAttribute('data-alt') || '');
  });

  function goTo(idx) {
    if (imgUrls.length === 0) return;
    idx = (idx + imgUrls.length) % imgUrls.length;
    currentIdx = idx;

    if (galleryImg) {
      galleryImg.src = imgUrls[idx];
      galleryImg.alt = imgAlts[idx];
    }

    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === idx);
      t.setAttribute('aria-current', i === idx ? 'true' : 'false');
    });
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === idx);
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      goTo(parseInt(thumb.getAttribute('data-index') || '0', 10));
    });
  });

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIdx - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIdx + 1); });

  // Keyboard nav
  var gallery = document.getElementById('pd-gallery');
  if (gallery && imgUrls.length > 1) {
    gallery.setAttribute('tabindex', '0');
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIdx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIdx + 1); }
    });
  }

  // ?? Variants ?????????????????????????????????????????????
  var atcBtnEl = document.getElementById('pd-atc-btn');
  var variantData = atcBtnEl ? JSON.parse(atcBtnEl.getAttribute('data-variants') || '[]') : [];
  var selectedOptions = [];

  // Seed from current variant (match server-rendered variant id, then fall back)
  var initialVariantId = atcBtnEl ? parseInt(atcBtnEl.getAttribute('data-variant-id') || '0', 10) : 0;
  var initialVariant = variantData.find(function (v) { return v.id === initialVariantId; })
    || variantData.find(function (v) { return v.available; })
    || variantData[0];
  if (initialVariant) {
    selectedOptions = initialVariant.options.slice();
  }

  var variantBtnGroups = document.querySelectorAll('[data-option-index]');

  function findMatchingVariant() {
    return variantData.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
    });
  }

  function updatePriceUI(variant) {
    if (!variant) return;
    var priceEl = document.getElementById('pd-price');
    var compareEl = document.getElementById('pd-compare');
    var savingsEl = document.getElementById('pd-savings');
    var atcLabel = document.getElementById('pd-atc-label');
    var atcBtn = document.getElementById('pd-atc-btn');
    var stickyVariantId = document.getElementById('sbb-variant-id');

    var price = variant.price;
    var comparePrice = variant.compare_at_price;

    function money(paise) {
      return '?' + Math.round(paise / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    if (priceEl) priceEl.textContent = money(price);
    if (atcLabel) atcLabel.textContent = 'Add to Cart - ' + money(price);
    if (atcBtn) atcBtn.setAttribute('data-variant-id', variant.id);
    if (stickyVariantId) stickyVariantId.value = variant.id;

    if (comparePrice && comparePrice > price) {
      if (compareEl) { compareEl.textContent = money(comparePrice); compareEl.style.display = ''; }
      if (savingsEl) { savingsEl.textContent = 'You save ' + money(comparePrice - price); savingsEl.style.display = ''; }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (savingsEl) savingsEl.style.display = 'none';
    }

    // Disable ATC if unavailable
    if (atcBtn) atcBtn.disabled = !variant.available;
    if (atcLabel && !variant.available) atcLabel.textContent = 'Sold Out';

    // Dispatch event for sticky bar
    document.dispatchEvent(new CustomEvent('pd:variant-changed', { detail: { variant: variant } }));
  }

  variantBtnGroups.forEach(function (group) {
    var optionIndex = parseInt(group.getAttribute('data-option-index') || '0', 10);
    group.querySelectorAll('.pd-buy__variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-value');
        selectedOptions[optionIndex] = value;

        // Update active state
        group.querySelectorAll('.pd-buy__variant-btn').forEach(function (b) {
          b.classList.toggle('is-selected', b.getAttribute('data-value') === value);
        });

        // Update label
        var label = document.getElementById('pd-option-val-' + optionIndex);
        if (label) label.textContent = value;

        var match = findMatchingVariant();
        if (match) updatePriceUI(match);
      });
    });
  });

  // ?? Quantity ??????????????????????????????????????????????
  var qty = 1;
  var qtyVal = document.getElementById('pd-qty-val');
  var qtyDec = document.getElementById('pd-qty-dec');
  var qtyInc = document.getElementById('pd-qty-inc');

  function setQty(n) {
    qty = Math.min(10, Math.max(1, n));
    if (qtyVal) qtyVal.textContent = qty;
  }

  if (qtyDec) qtyDec.addEventListener('click', function () { setQty(qty - 1); });
  if (qtyInc) qtyInc.addEventListener('click', function () { setQty(qty + 1); });

  // ?? Add to cart ???????????????????????????????????????????
  var atcBtn = document.getElementById('pd-atc-btn');
  var atcLabel = document.getElementById('pd-atc-label');

  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var variantId = parseInt(atcBtn.getAttribute('data-variant-id') || '0', 10);
      if (!variantId) return;

      var originalText = atcLabel ? atcLabel.textContent : 'Add to Cart';
      atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Adding.';

      if (typeof window.addToCart === 'function') {
        window.addToCart(variantId, qty)
          .then(function () {
            if (atcLabel) atcLabel.textContent = 'Added ?';
            setTimeout(function () {
              atcBtn.disabled = false;
              if (atcLabel) atcLabel.textContent = originalText;
            }, 1800);
          })
          .catch(function () {
            atcBtn.disabled = false;
            if (atcLabel) atcLabel.textContent = originalText;
          });
      } else {
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = originalText;
      }
    });
  }

  // ?? Accordion ?????????????????????????????????????????????
  document.querySelectorAll('.pd-acc-item__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.pd-acc-item');
      if (!item) return;
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"]) return;
  try {
    
(function () {
  var root = document.getElementById('qz-root');
  var screen = document.getElementById('qz-screen');
  if (!root || !screen) return;

  /* Parse live product data injected by Liquid */
  var PRODS = {};
  try { PRODS = JSON.parse(root.getAttribute('data-products') || '{}'); } catch (e) {}

  /* ── Questions (exact from quizData.ts) ──────────────────── */
  var QS = [
    {
      q: 'How do you feel most mornings when you wake up?',
      sub: 'Be honest — this shapes your entire recommendation.',
      opts: [
        { label: 'Tired even after 7–8 hours of sleep', sc: { energy: 3, nutrition: 1 } },
        { label: 'Heavy, bloated or sluggish', sc: { digestion: 3, liver: 2 } },
        { label: 'Fine in the morning but crash by afternoon', sc: { sugar: 3, energy: 2 } },
        { label: 'Foggy, anxious or low motivation', sc: { energy: 2, immunity: 1 } },
        { label: 'Pretty good — just want to stay healthy', sc: { nutrition: 3, immunity: 1 } }
      ]
    },
    {
      q: 'In the last 3 months, which of these have you noticed?',
      sub: 'These are early signals your body sends before a condition becomes serious.',
      opts: [
        { label: 'Belly fat that won\'t go despite diet changes', sc: { liver: 3, sugar: 1 } },
        { label: 'Sugar cravings or energy crash after meals', sc: { sugar: 3, energy: 2 } },
        { label: 'Feeling full or heavy after even small meals', sc: { liver: 2, digestion: 2 } },
        { label: 'Skin dullness, hair fall or slow healing', sc: { nutrition: 2, immunity: 2 } },
        { label: 'Frequent colds, cough or infections', sc: { immunity: 3 } },
        { label: 'None of these', sc: { nutrition: 2 } }
      ]
    },
    {
      q: 'Have you been told any of the following by a doctor or during a health checkup?',
      sub: 'Select the closest match — this helps us personalise your food routine accurately.',
      opts: [
        { label: 'Fatty liver or high liver enzymes (SGPT/SGOT)', sc: { liver: 4 } },
        { label: 'Pre-diabetes or HbA1c above 5.7', sc: { sugar: 4 } },
        { label: 'High cholesterol or triglycerides', sc: { liver: 2, sugar: 2 } },
        { label: 'Vitamin D, B12 or iron deficiency', sc: { energy: 3, nutrition: 2 } },
        { label: 'Nothing specific — routine checkup was fine', sc: { nutrition: 2, immunity: 1 } }
      ]
    },
    {
      q: 'How often do you eat outside food, packaged snacks or refined flour (maida)?',
      sub: 'Maida and packaged food are the leading dietary triggers of fatty liver and blood sugar issues in India.',
      opts: [
        { label: 'Daily or almost daily', sc: { liver: 3, sugar: 2, digestion: 1 } },
        { label: '3–4 times a week', sc: { liver: 2, sugar: 2 } },
        { label: 'Once or twice a week', sc: { liver: 1, sugar: 1 } },
        { label: 'Rarely — mostly home cooked whole foods', sc: { nutrition: 2, immunity: 1 } }
      ]
    },
    {
      q: 'Who are you finding this routine for?',
      sub: 'This helps us adjust the recommendation and how we present it.',
      opts: [
        { label: 'Myself', sc: { energy: 1 } },
        { label: 'My spouse or partner', sc: { nutrition: 1 } },
        { label: 'A parent aged 60 or above', sc: { nutrition: 2, digestion: 1 } },
        { label: 'My whole family', sc: { nutrition: 3 } }
      ]
    },
    {
      q: 'How committed are you to making a change in the next 30 days?',
      sub: 'Honest answer helps us set the right expectation for your routine.',
      opts: [
        { label: 'Very — I have already tried other things and need something that works', sc: { liver: 1, sugar: 1 } },
        { label: 'Motivated — I am ready to start a daily routine', sc: { energy: 1, nutrition: 1 } },
        { label: 'Curious — just exploring what is available', sc: { nutrition: 1 } },
        { label: 'I am buying this for someone else', sc: { nutrition: 2 } }
      ]
    }
  ];

  /* ── Result configs (exact from goalResults in quizData.ts) ── */
  var RES = {
    liver: {
      self: 'Your personalised liver support routine',
      other: 'A personalised liver support routine for your family member',
      insight: 'Your answers match a pattern we see in many Indians between 30–50 — sedentary work, processed food, and early metabolic stress on the liver. The encouraging news: a 2023 human RCT published in the Journal of Hepatology showed significant improvement in liver enzyme levels with dietary intervention alone in 8 weeks.',
      rct: 'Backed by human RCT evidence — not just traditional use.',
      kitHandle: 'liver-reset-kit-8-science-backed-foods',
      kitName: 'Liver Reset Kit — 8 Science-Backed Foods',
      kitPrice: 299900,
      p1: 'raw-jungle-honey', p1b: 'Supports liver detox & reduces oxidative stress',
      p2: 'jamun-vinegar', p2b: 'Helps reduce liver fat & improves metabolism',
      guideTitle: 'Why fatty liver is rising',
      guideDesc: 'Learn the root causes and how to reverse early signs naturally.',
      guideLink: '/pages/fatty-liver'
    },
    sugar: {
      self: 'Your personalised blood sugar support routine',
      other: 'A personalised blood sugar routine for your family member',
      insight: 'Your answers point to unstable blood sugar patterns — a combination of dietary triggers and metabolic stress. A 2022 meta-analysis of 27 RCTs found that specific whole food interventions reduced fasting blood sugar by an average of 18% without medication.',
      rct: 'Backed by meta-analysis of 27 human RCTs.',
      kitHandle: 'sugar-balance-kit-6-science-backed-foods',
      kitName: 'Sugar Balance Kit',
      kitPrice: 159900,
      p1: 'jamun-vinegar', p1b: 'Lowers glycemic response after meals',
      p2: 'organic-turmeric-powder', p2b: 'Improves insulin sensitivity naturally',
      guideTitle: 'How to manage blood sugar naturally',
      guideDesc: 'Simple dietary changes that make a big difference.',
      guideLink: '/pages/sugar-imbalance'
    },
    immunity: {
      self: 'Your personalised immunity routine',
      other: 'A personalised immunity routine for your family member',
      insight: 'Your body is showing early signs of immune stress — frequent infections and slow recovery are the first signals. A 2021 systematic review confirmed that micronutrient-dense whole foods significantly reduce infection frequency within 4–6 weeks of consistent use.',
      rct: 'Backed by systematic review evidence.',
      kitHandle: 'immunity-kit',
      kitName: 'Immunity Boost Kit',
      kitPrice: 229900,
      p1: 'shilajit', p1b: 'Himalayan mineral complex for deep immunity',
      p2: 'moringa-powder', p2b: '7x more Vitamin C than oranges',
      guideTitle: 'Build lasting immunity naturally',
      guideDesc: 'Go beyond supplements — build real, lasting immunity.',
      guideLink: '/pages/immunity'
    },
    digestion: {
      self: 'Your personalised gut health routine',
      other: 'A personalised gut routine for your family member',
      insight: 'Your gut is sending clear signals. Bloating, heaviness and sluggish digestion are not normal — they are signs your digestive ecosystem needs rebuilding. Human trials show that traditional fermented foods and bile-supporting fats can restore gut function within 3–4 weeks.',
      rct: 'Backed by clinical gut health research.',
      kitHandle: 'gut-health-kit',
      kitName: 'Gut Health Kit',
      kitPrice: 319900,
      p1: 'a2-bilona-ghee', p1b: 'Lubricates gut lining & aids nutrient absorption',
      p2: 'jamun-vinegar', p2b: 'Improves digestive enzyme production',
      guideTitle: 'How to detox naturally',
      guideDesc: 'A simple guide to restoring gut health from the inside out.',
      guideLink: '/pages/digestion-issues'
    },
    energy: {
      self: 'Your personalised energy restoration routine',
      other: 'A personalised energy routine for your family member',
      insight: 'Chronic fatigue is almost always a nutrition gap — not laziness. Your pattern suggests mitochondrial underperformance, which responds well to specific adaptogens and mineral-rich foods. A 2020 RCT showed significant reduction in fatigue scores with consistent adaptogen supplementation over 8 weeks.',
      rct: 'Backed by RCT evidence on adaptogens and fatigue.',
      kitHandle: 'energy-vitality-kit',
      kitName: 'Energy & Vitality Kit',
      kitPrice: 299900,
      p1: 'shilajit', p1b: 'Boosts mitochondrial energy production',
      p2: 'moringa-powder', p2b: 'Iron-rich superfood that fights fatigue',
      guideTitle: 'Beat fatigue without caffeine',
      guideDesc: 'Natural ways to boost energy and mental clarity daily.',
      guideLink: '/pages/low-energy'
    },
    nutrition: {
      self: 'Your personalised family nutrition routine',
      other: 'A personalised daily nutrition routine for your family',
      insight: 'Prevention is always easier and far cheaper than treatment. Your family\'s daily food foundation — the oils, sweeteners and staples you use every day — determines long-term health more than any supplement. Small upgrades to daily staples create compounding health benefits over months and years.',
      rct: 'Based on longitudinal dietary research across Indian populations.',
      kitHandle: 'daily-nutrition-kit',
      kitName: 'Daily Nutrition Kit',
      kitPrice: 239900,
      p1: 'a2-bilona-ghee', p1b: 'Essential healthy fats for the whole family',
      p2: 'raw-jungle-honey', p2b: 'Daily immunity & sweetener replacement',
      guideTitle: 'Complete family nutrition guide',
      guideDesc: 'Everything your family needs for daily preventive health — from pure ghee and honey to superfoods.',
      guideLink: '/pages/family-health'
    }
  };

  /* ── State ───────────────────────────────────────────────── */
  var state = {
    qIndex: 0,
    answers: new Array(QS.length).fill(null),
    forSelf: true
  };
  var advancing = false;

  /* ── Helpers ─────────────────────────────────────────────── */
  function money(paise) {
    return '₹' + Math.round(paise / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }
  function icon(path, size) {
    size = size || 14;
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">' + path + '</svg>';
  }
  var ARROW_R = icon('<path d="M5 12h14M12 5l7 7-7 7"/>');
  var ARROW_L = icon('<path d="M19 12H5M12 19l-7-7 7-7"/>');

  /* ── Transition ──────────────────────────────────────────── */
  function transition(renderFn) {
    screen.style.opacity = '0';
    screen.style.transform = 'translateY(-5px)';
    screen.style.transition = 'opacity 180ms ease, transform 180ms ease';
    setTimeout(function () {
      renderFn();
      advancing = false;
      screen.style.transition = 'none';
      screen.style.opacity = '0';
      screen.style.transform = 'translateY(8px)';
      void screen.offsetWidth;
      screen.style.transition = 'opacity 240ms ease, transform 240ms ease';
      screen.style.opacity = '1';
      screen.style.transform = 'translateY(0)';
    }, 180);
  }

  /* ── Progress bar ────────────────────────────────────────── */
  function progHtml(step, total) {
    var pct = total > 0 ? Math.round((step / total) * 100) : 0;
    return '<div class="qz__prog-wrap"><div class="qz__prog-fill" style="width:' + pct + '%"></div></div>';
  }

  /* ── Scoring ─────────────────────────────────────────────── */
  function calcResult() {
    var scores = { liver: 0, sugar: 0, immunity: 0, digestion: 0, energy: 0, nutrition: 0 };
    state.answers.forEach(function (ansIdx, qi) {
      if (ansIdx !== null) {
        var sc = QS[qi].opts[ansIdx].sc;
        Object.keys(sc).forEach(function (k) { scores[k] += sc[k]; });
      }
    });
    return Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; })[0];
  }

  /* ── Retake helper ───────────────────────────────────────── */
  function retakeHtml() {
    return '<div class="qz__retake-wrap"><button class="qz__retake" id="qz-retake">' + icon('<path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 1 0 .49-4.54"/>', 13) + ' Retake quiz</button></div>';
  }
  function bindRetake() {
    var btn = document.getElementById('qz-retake');
    if (!btn) return;
    btn.addEventListener('click', function () {
      state.qIndex = 0;
      state.answers = new Array(QS.length).fill(null);
      state.forSelf = true;
      transition(renderIntro);
    });
  }

  /* ── Render: Intro ───────────────────────────────────────── */
  function renderIntro() {
    var heading = esc(root.getAttribute('data-heading') || 'Find What Your Body Needs');
    var sub = esc(root.getAttribute('data-subheading') || 'Answer 6 quick questions about your concern, age & lifestyle — get a personalised kit, top products, and a health guide just for you.');
    screen.innerHTML = [
      '<div class="qz__intro">',
        '<div class="qz__intro-badge">',
          icon('<circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>', 14),
          ' 2-Minute Health Quiz',
        '</div>',
        '<h1 class="qz__intro-h">', heading, '</h1>',
        '<p class="qz__intro-sub">', sub, '</p>',
        '<button class="qz__btn-start" id="qz-start">Take the Quiz ', ARROW_R, '</button>',
      '</div>'
    ].join('');
    document.getElementById('qz-start').addEventListener('click', function () {
      transition(function () { state.qIndex = 0; renderQuestion(); });
    });
  }

  /* ── Render: Question ────────────────────────────────────── */
  function renderQuestion() {
    var qi = state.qIndex;
    var qd = QS[qi];
    var sel = state.answers[qi];
    var total = QS.length;

    var optsHtml = qd.opts.map(function (opt, idx) {
      return '<button class="qz__opt' + (sel === idx ? ' is-selected' : '') + '" data-idx="' + idx + '">' +
        '<span class="qz__opt-dot"></span><span>' + esc(opt.label) + '</span></button>';
    }).join('');

    screen.innerHTML = [
      '<div class="qz__counter">Question ' + (qi + 1) + ' of ' + total + '</div>',
      progHtml(qi + 1, total),
      '<h2 class="qz__question">' + esc(qd.q) + '</h2>',
      qd.sub ? '<p class="qz__subtext">' + esc(qd.sub) + '</p>' : '',
      '<div class="qz__options">' + optsHtml + '</div>',
      '<div class="qz__nav">',
        '<button class="qz__btn-back" id="qz-back"' + (qi === 0 ? ' disabled' : '') + '>' + ARROW_L + ' Back</button>',
        '<button class="qz__btn-next" id="qz-next"' + (sel === null ? ' disabled' : '') + '>',
          (qi === total - 1 ? 'See My Results' : 'Next') + ' ' + ARROW_R,
        '</button>',
      '</div>'
    ].join('');

    screen.querySelectorAll('.qz__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (advancing) return;
        var idx = parseInt(btn.getAttribute('data-idx'), 10);
        state.answers[qi] = idx;
        if (qi === 4) { state.forSelf = QS[4].opts[idx].label === 'Myself'; }
        screen.querySelectorAll('.qz__opt').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var nextBtn = document.getElementById('qz-next');
        if (nextBtn) nextBtn.disabled = false;
        setTimeout(advance, 400);
      });
    });

    document.getElementById('qz-back').addEventListener('click', function () {
      if (advancing || qi === 0) return;
      advancing = true;
      transition(function () { state.qIndex = qi - 1; renderQuestion(); });
    });

    document.getElementById('qz-next').addEventListener('click', function () {
      if (state.answers[qi] === null) return;
      advance();
    });
  }

  function advance() {
    if (advancing) return;
    var qi = state.qIndex;
    if (state.answers[qi] === null) return;
    advancing = true;
    if (qi === 1) {
      transition(renderMidInsight);
      return;
    }
    if (qi < QS.length - 1) {
      transition(function () { state.qIndex = qi + 1; renderQuestion(); });
    } else {
      var key = calcResult();
      transition(function () { renderResult(key); });
    }
  }

  /* ── Render: Mid-insight ─────────────────────────────────── */
  function renderMidInsight() {
    screen.innerHTML = [
      '<div class="qz__mid-card">',
        '<h3 class="qz__mid-h">What your answers suggest so far</h3>',
        '<p class="qz__mid-p">These symptoms are early signals that your liver or blood sugar regulation may need attention. Both are highly reversible — the right food choices, taken consistently, have shown results in as little as 4–8 weeks in clinical trials.</p>',
        '<button class="qz__btn-next" id="qz-mid-go">See your full result →</button>',
      '</div>'
    ].join('');
    document.getElementById('qz-mid-go').addEventListener('click', function () {
      transition(function () { state.qIndex = 2; renderQuestion(); });
    });
  }

  /* ── Render: Result ──────────────────────────────────────── */
  function renderResult(key) {
    var r = RES[key] || RES['nutrition'];
    var heading = state.forSelf ? r.self : r.other;
    var kitP = PRODS[r.kitHandle] || {};
    var p1P = PRODS[r.p1] || {};
    var p2P = PRODS[r.p2] || {};
    var showSec = root.getAttribute('data-secondary') !== 'false';

    /* Fallback if kit product not set up in Shopify yet */
    if (!kitP.vid) {
      screen.innerHTML = [
        '<div class="qz__result-label">Your Personalised Result</div>',
        '<h2 class="qz__result-h">' + esc(heading) + '</h2>',
        '<div class="qz__fallback">',
          '<p class="qz__fallback-p">Based on your answers, we recommend our <strong>' + esc(r.kitName) + '</strong>.</p>',
          '<a href="/collections/all" class="qz__btn-browse">Browse all products</a>',
        '</div>',
        retakeHtml()
      ].join('');
      bindRetake();
      return;
    }

    /* Kit image */
    var kitImgHtml = kitP.image
      ? '<img src="' + esc(kitP.image) + '" alt="' + esc(kitP.title || r.kitName) + '" class="qz__kit-img" width="64" height="64" loading="lazy">'
      : '<div class="qz__kit-img"></div>';

    /* Product picks */
    var picks = [];
    if (p1P.vid) picks.push({ p: p1P, benefit: r.p1b });
    if (showSec && p2P.vid) picks.push({ p: p2P, benefit: r.p2b });

    var picksHtml = '';
    if (picks.length) {
      picksHtml = '<div class="qz__picks-card"><span class="qz__sect-label">🏆 Top picks for you</span><div class="qz__picks-grid">' +
        picks.map(function (item, i) {
          var p = item.p;
          var img = p.image
            ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title || '') + '" class="qz__pick-img" width="56" height="56" loading="lazy">'
            : '<div class="qz__pick-img"></div>';
          return '<div class="qz__pick">' + img +
            '<div class="qz__pick-body">' +
              '<p class="qz__pick-name">' + esc(p.title || '') + '</p>' +
              '<p class="qz__pick-benefit">' + esc(item.benefit) + '</p>' +
              '<div class="qz__pick-row"><span class="qz__pick-price">' + money(p.price || 0) + '</span>' +
              '<button class="qz__pick-add" data-vid="' + (p.vid || 0) + '" data-pi="' + i + '">+ Add</button></div>' +
            '</div></div>';
        }).join('') +
      '</div></div>';
    }

    /* Guide card */
    var guideHtml = '<a href="' + esc(r.guideLink) + '" class="qz__guide-card">' +
      '<span class="qz__sect-label">📖 Recommended guide</span>' +
      '<div class="qz__guide-row">' +
        '<div class="qz__guide-icon">' + icon('<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>', 18) + '</div>' +
        '<div class="qz__guide-text"><p class="qz__guide-title">' + esc(r.guideTitle) + '</p><p class="qz__guide-desc">' + esc(r.guideDesc) + '</p></div>' +
        '<span class="qz__guide-arrow">' + icon('<path d="M5 12h14M12 5l7 7-7 7"/>', 16) + '</span>' +
      '</div>' +
    '</a>';

    screen.innerHTML = [
      '<div class="qz__result-label">Your Personalised Result</div>',
      '<h2 class="qz__result-h">' + esc(heading) + '</h2>',
      '<div class="qz__result-insight">',
        '<p class="qz__result-insight-p">' + esc(r.insight) + '</p>',
        '<small class="qz__result-rct">' + esc(r.rct) + '</small>',
      '</div>',
      '<div class="qz__kit-card">',
        '<span class="qz__sect-label">🎁 Recommended kit</span>',
        '<div class="qz__kit-row">',
          '<div class="qz__kit-info">' + kitImgHtml +
            '<div><p class="qz__kit-name">' + esc(kitP.title || r.kitName) + '</p><p class="qz__kit-tagline">' + esc(r.kitName) + '</p></div>' +
          '</div>',
          '<div class="qz__kit-right">',
            '<span class="qz__kit-price">' + money(kitP.price || r.kitPrice) + '</span>',
            '<button class="qz__kit-atc" id="qz-kit-atc" data-vid="' + kitP.vid + '">' +
              icon('<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>', 14) +
              ' Add Kit</button>',
          '</div>',
        '</div>',
        '<a href="' + esc(kitP.url || '/collections/all') + '" class="qz__kit-view">View full details →</a>',
      '</div>',
      picksHtml,
      guideHtml,
      retakeHtml()
    ].join('');

    /* Kit ATC */
    var kitBtn = document.getElementById('qz-kit-atc');
    if (kitBtn) {
      kitBtn.addEventListener('click', function () {
        var vid = parseInt(kitBtn.getAttribute('data-vid') || '0', 10);
        if (!vid || typeof window.addToCart !== 'function') {
          window.location.href = kitP.url || '/collections/all';
          return;
        }
        var orig = kitBtn.innerHTML;
        kitBtn.disabled = true;
        kitBtn.textContent = 'Adding…';
        window.addToCart(vid, 1)
          .then(function () {
            kitBtn.textContent = 'Added ✓';
            setTimeout(function () { kitBtn.disabled = false; kitBtn.innerHTML = orig; }, 1800);
          })
          .catch(function () { kitBtn.disabled = false; kitBtn.innerHTML = orig; });
      });
    }

    /* Pick ATC buttons */
    screen.querySelectorAll('.qz__pick-add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = parseInt(btn.getAttribute('data-vid') || '0', 10);
        if (!vid || typeof window.addToCart !== 'function') return;
        var orig = btn.textContent;
        btn.disabled = true;
        btn.textContent = '✓';
        window.addToCart(vid, 1)
          .catch(function () {})
          .then(function () {
            setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1500);
          });
      });
    });

    bindRetake();
  }

  /* ── Init ────────────────────────────────────────────────── */
  renderIntro();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-article"] && !Shopify.designMode) return;
  try {
    
(function() {
  var links = document.querySelectorAll('.ra__toc-link');
  var sections = [];
  links.forEach(function(l) {
    var id = l.getAttribute('href').replace('#','');
    var el = document.getElementById(id);
    if (el) sections.push({ el: el, link: l });
  });
  if (!sections.length) return;
  var onScroll = function() {
    var scrollY = window.scrollY + 120;
    var active = sections[0];
    sections.forEach(function(s) { if (scrollY >= s.el.offsetTop) active = s; });
    links.forEach(function(l) { l.classList.remove('ra__toc-link--active'); });
    if (active) active.link.classList.add('ra__toc-link--active');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  document.querySelectorAll('.ra__shop-atc').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var vid = parseInt(btn.dataset.vid, 10);
      if (!vid || typeof window.addToCart !== 'function') return;
      var orig = btn.innerHTML;
      btn.disabled = true;
      window.addToCart(vid, 1).then(function() {
        btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';
        setTimeout(function() { btn.disabled = false; btn.innerHTML = orig; }, 2000);
      }).catch(function() { btn.disabled = false; btn.innerHTML = orig; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["start-here-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var btn = document.getElementById('sh-cta-btn');
  if (!btn) return;

  btn.addEventListener('click', function () {
    var ids = (btn.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
    if (!ids.length) return;

    var defaultSpan = btn.querySelector('.sh-hero__cta-default');
    var addedSpan   = btn.querySelector('.sh-hero__cta-added');

    btn.disabled = true;
    defaultSpan.style.display = 'none';
    addedSpan.style.display = 'inline';

    var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart/add failed'); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        setTimeout(function () {
          btn.disabled = false;
          defaultSpan.style.display = '';
          addedSpan.style.display = 'none';
        }, 2000);
      })
      .catch(function () {
        btn.disabled = false;
        defaultSpan.style.display = '';
        addedSpan.style.display = 'none';
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-buy-bar"]) return;
  try {
    
(function () {
  var sbb = document.getElementById('sbb');
  if (!sbb) return;

  var variantInput = document.getElementById('sbb-variant-id');
  var sbbPrice = document.getElementById('sbb-price');
  var sbbMobilePrice = document.getElementById('sbb-mobile-price');
  var sbbQtyEl = document.getElementById('sbb-qty');
  var sbbMobileQtyEl = document.getElementById('sbb-mobile-qty');
  var sbbDecBtn = document.getElementById('sbb-dec');
  var sbbIncBtn = document.getElementById('sbb-inc');
  var sbbMobileDecBtn = document.getElementById('sbb-mobile-dec');
  var sbbMobileIncBtn = document.getElementById('sbb-mobile-inc');
  var sbbAtcDesktop = document.getElementById('sbb-atc-desktop');
  var sbbAtcMobile = document.getElementById('sbb-atc-mobile');

  var qty = 1;

  // ── Visibility via IntersectionObserver ───────────────────
  function initVisibility() {
    var primaryAtcEl = document.getElementById('wkpdp-atc') || document.getElementById('primary-atc-button');
    function updateVisibility() {
      var show = primaryAtcEl ? primaryAtcEl.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
      sbb.classList.toggle('is-visible', show);
      sbb.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('sticky-atc-active', show);
    }

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVisibility, { once: true });
  } else {
    initVisibility();
  }

  // ── Sync variant changes from product-detail ───────────────
  document.addEventListener('pd:variant-changed', function (e) {
    var variant = e.detail.variant;
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    function money(p) { return '₹' + Math.round(p / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    var priceStr = money(variant.price * qty);
    if (sbbPrice) sbbPrice.textContent = priceStr;
    if (sbbMobilePrice) sbbMobilePrice.textContent = priceStr;

    var unavailable = !variant.available;
    if (sbbAtcDesktop) { sbbAtcDesktop.disabled = unavailable; sbbAtcDesktop.textContent = unavailable ? 'Sold Out' : 'Add to Cart'; }
    if (sbbAtcMobile) { sbbAtcMobile.disabled = unavailable; sbbAtcMobile.textContent = unavailable ? 'Sold Out' : 'Add to Cart'; }
  });

  // ── Quantity ───────────────────────────────────────────────
  function setQty(n) {
    qty = Math.min(10, Math.max(1, n));
    if (sbbQtyEl) sbbQtyEl.textContent = qty;
    if (sbbMobileQtyEl) sbbMobileQtyEl.textContent = qty;
  }

  if (sbbDecBtn) sbbDecBtn.addEventListener('click', function () { setQty(qty - 1); });
  if (sbbIncBtn) sbbIncBtn.addEventListener('click', function () { setQty(qty + 1); });
  if (sbbMobileDecBtn) sbbMobileDecBtn.addEventListener('click', function () { setQty(qty - 1); });
  if (sbbMobileIncBtn) sbbMobileIncBtn.addEventListener('click', function () { setQty(qty + 1); });

  // ── ATC ────────────────────────────────────────────────────
  function handleAtc(btn) {
    var variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
    if (!variantId || !window.addToCart) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    window.addToCart(variantId, qty)
      .then(function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        }, 1800);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  if (sbbAtcDesktop) sbbAtcDesktop.addEventListener('click', function () { handleAtc(sbbAtcDesktop); });
  if (sbbAtcMobile) sbbAtcMobile.addEventListener('click', function () { handleAtc(sbbAtcMobile); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-social"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sub-faq__btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var item = btn.closest('.sub-faq__item');
    var isOpen = item.classList.contains('sub-faq__item--open');
    document.querySelectorAll('.sub-faq__item--open').forEach(function(openItem) {
      openItem.classList.remove('sub-faq__item--open');
      openItem.querySelector('.sub-faq__btn').setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('sub-faq__item--open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var lightbox = document.getElementById('ugc-lightbox');
  var lbVideo = document.getElementById('ugc-lightbox-video');
  var lbClose = document.getElementById('ugc-lightbox-close');
  var lbInner = document.getElementById('ugc-lightbox-inner');
  if (!lightbox || !lbVideo) return;

  function openLightbox(videoSrc, posterSrc) {
    lbVideo.poster = posterSrc || '';
    lbVideo.src = videoSrc;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lbVideo.play().catch(function () {});
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lbVideo.pause();
    lbVideo.src = '';
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.ugc-card__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-video-src');
      var poster = thumb.getAttribute('data-video-poster');
      if (src) openLightbox(src, poster);
    });
  });

  lbClose.addEventListener('click', closeLightbox);

  lightbox.addEventListener('click', function (e) {
    if (!lbInner.contains(e.target)) closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
(function () {
  var STORAGE_KEY = 'welcome_shown';
  var COOKIE_KEY = 'welcome_shown';
  var overlay = document.getElementById('wp-overlay');
  if (!overlay) return;

  var delay = parseInt(overlay.getAttribute('data-delay'), 10) || 4000;
  var wanum = overlay.getAttribute('data-wanum') || '';
  var code = overlay.getAttribute('data-code') || '';

  function getCookie(name) {
    var parts = document.cookie.split('; ');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].split('=');
      if (decodeURIComponent(p[0]) === name) return decodeURIComponent(p[1] || '');
    }
    return null;
  }

  if (sessionStorage.getItem(STORAGE_KEY)) return;
  if (getCookie(COOKIE_KEY)) return;

  var path = window.location.pathname;
  if (path.indexOf('/checkout') !== -1 || path === '/cart') return;

  window.po = window.po || {};
  window.po.welcomeOpen = false;

  function openPopup() {
    var el = document.getElementById('wp-overlay');
    if (!el) return;
    el.removeAttribute('aria-hidden');
    el.classList.add('is-open');
    window.po.welcomeOpen = true;
    document.body.style.overflow = 'hidden';
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    var exp = new Date();
    exp.setDate(exp.getDate() + 30);
    document.cookie = encodeURIComponent(COOKIE_KEY) + '=1; expires=' + exp.toUTCString() + '; path=/; SameSite=Lax';
  }

  function closePopup() {
    var el = document.getElementById('wp-overlay');
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    window.po.welcomeOpen = false;
    document.body.style.overflow = '';
  }

  setTimeout(openPopup, delay);

  var closeBtn = document.getElementById('wp-close');
  if (closeBtn) closeBtn.addEventListener('click', closePopup);

  var dismissBtn = document.getElementById('wp-dismiss');
  if (dismissBtn) dismissBtn.addEventListener('click', closePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup();
  });

  var submitBtn = document.getElementById('wp-submit');
  var phoneInput = document.getElementById('wp-phone');
  var formState = document.getElementById('wp-form-state');
  var successState = document.getElementById('wp-success-state');
  var successClose = document.getElementById('wp-success-close');

  if (submitBtn && phoneInput) {
    submitBtn.addEventListener('click', function () {
      var phone = phoneInput.value.replace(/\D/g, '');
      if (phone.length < 10) {
        phoneInput.style.borderColor = '#e53e3e';
        phoneInput.setAttribute('aria-invalid', 'true');
        phoneInput.focus();
        return;
      }
      phoneInput.style.borderColor = '';
      phoneInput.removeAttribute('aria-invalid');
      var msg = 'Hi! I want to claim my ' + code + ' welcome code for 5% off my first order.';
      window.open('https://wa.me/' + wanum + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
      if (formState) formState.setAttribute('hidden', '');
      if (successState) successState.removeAttribute('hidden');
    });

    phoneInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submitBtn.click();
    });
  }

  if (successClose) successClose.addEventListener('click', closePopup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-kit-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Quantity stepper ──────────────────────────────────── */
  var qtyEl   = document.getElementById('wkpdp-qty');
  var qtyMinus = document.getElementById('wkpdp-qty-minus');
  var qtyPlus  = document.getElementById('wkpdp-qty-plus');
  var qty = 1;

  if (qtyMinus && qtyPlus && qtyEl) {
    qtyMinus.addEventListener('click', function () {
      if (qty > 1) { qty--; qtyEl.textContent = qty; }
    });
    qtyPlus.addEventListener('click', function () {
      qty++;
      qtyEl.textContent = qty;
    });
  }

  /* ── Add to cart ───────────────────────────────────────── */
  function handleAtc(btn) {
    if (!btn) return;
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      if (typeof window.addToCart === 'function') {
        window.addToCart(variantId, qty)
          .then(function () {
            btn.textContent = 'Added ✓';
            setTimeout(function () {
              btn.disabled = false;
              btn.innerHTML = originalText;
            }, 1800);
          })
          .catch(function () {
            btn.disabled = false;
            btn.innerHTML = originalText;
          });
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.disabled = false; btn.innerHTML = originalText; }, 1800);
        })
        .catch(function () { btn.disabled = false; btn.innerHTML = originalText; });
      }
    });
  }

  handleAtc(document.getElementById('wkpdp-atc'));
  handleAtc(document.getElementById('wkpdp-cta-atc'));

  /* ── FAQ accordion ─────────────────────────────────────── */
  document.querySelectorAll('.wkpdp__faq-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.wkpdp__faq-item');
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.wkpdp__faq-item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('.wkpdp__faq-btn').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Smooth scroll for sub-nav ─────────────────────────── */
  document.querySelectorAll('.wkpdp__subnav-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-kit"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.wkit__atc[data-vid]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var vid = parseInt(btn.getAttribute('data-vid') || '0', 10);
    if (!vid || typeof window.addToCart !== 'function') return;
    var orig = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    window.addToCart(vid, 1)
      .then(function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.disabled = false; btn.innerHTML = orig; }, 2000);
      })
      .catch(function () { btn.disabled = false; btn.innerHTML = orig; });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-kits"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.wk-kit__atc[data-vid]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var vid = parseInt(btn.getAttribute('data-vid') || '0', 10);
      if (!vid || typeof window.addToCart !== 'function') return;
      var orig = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      window.addToCart(vid, 1)
        .then(function () {
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.disabled = false; btn.innerHTML = orig; }, 2000);
        })
        .catch(function () { btn.disabled = false; btn.innerHTML = orig; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
